<template>
<div>
  <rel-header>
    <form>
      <e-row mr>
        <e-col>
          <e-row class="large-mr erp-s-field-bold" mr>
            <e-col style="max-width: 140px">
              <erp-s-field label="Data inicial:">
                <datetime-modern-input v-model="filters.data1" date-type="date" date-format="##/##/####" />
              </erp-s-field>
            </e-col>
            <e-col style="max-width: 140px">
              <erp-s-field label="Data final:">
                <datetime-modern-input v-model="filters.data2" date-type="date" date-format="##/##/####" />
              </erp-s-field>
            </e-col>
            <e-col style="max-width: 200px">
              <erp-s-field label="Processo:">
                <u-input v-model="filters.processo" v-mask="'#######-##.####.#.##.####'" />
              </erp-s-field>
            </e-col>
            <e-col style="max-width: 200px">
              <erp-s-field label="Responsável:">
                <global-pessoa-input v-model="filters.responsavel" layout="float-icon input-hide-loading" :hide-underline="false" />
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t large-mr erp-s-field-bold" mr>
            <e-col style="max-width: 200px">
              <erp-s-field label="Cliente:">
                <global-pessoa-input v-model="filters.cliente" layout="float-icon input-hide-loading" :hide-underline="false" />
              </erp-s-field>
            </e-col>
            <e-col>
              <tribunal-select v-model="filters.tribunal" />
            </e-col>
            <e-col>
              <comarca-select :tribunal="filters.tribunal" limit="10000" v-model="filters.comarca" />
            </e-col>
            <e-col>
              <vara-select :comarca="filters.comarca" v-model="filters.vara" />
            </e-col>
          </e-row>
        </e-col>
        <e-col style="max-width: 120px; text-align: right;" class="flex items-center justify-end">
          <erp-s-field label="">
            <u-btn label="Gerar" color="green" :loading="gerando" @click="gerar" />
          </erp-s-field>
        </e-col>
      </e-row>
    </form>
  </rel-header>
</div>
</template>

<script>
import RelHeader from '@/components/relatorios/layout/RelHeader'
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import {ErpSField} from "uloc-vue-plugin-erp"
import {UInput} from "uloc-vue"
import DatetimeModernInput from "@/reuse/input/DatetimeModern"
import GlobalPessoaInput from "@/components/pessoa/components/include/pessoa/PessoaInput"
import {relatorio} from "@/domain/relatorios/services"
import {datePtToEn} from "@/utils/date"
import TribunalSelect from "@/components/processos/components/processos/include/TribunalSelect"
import VaraSelect from "@/components/processos/components/processos/include/VaraSelect";
import ComarcaSelect from "@/components/processos/components/processos/include/ComarcaSelect";

export default {
  name: "Visualizacao",
  data () {
    return {
      cache: {
        timestamp: null
      },
      fake: {
      },
      filters: {
        data1: null,
        data2: null,
        processo: null,
        responsavel: null,
        cliente: null,
        tribunal: null,
        comarca: null,
        vara: null
      },
      gerando: false
    }
  },
  methods: {
    gerar () {
      const filters = JSON.parse(JSON.stringify(this.filters))
      filters.data1 = filters.data1 ? datePtToEn(filters.data1) : null
      filters.data2 = filters.data2 ? datePtToEn(filters.data2) : null
      filters.responsavel = filters.responsavel && filters.responsavel.id ? filters.responsavel.id : null
      filters.cliente = filters.cliente && filters.cliente.id ? filters.cliente.id : null
      this.$uloc.loading.show({message: 'Gerando relatório'})
      this.gerando = true
      relatorio('produtividade', filters)
          .then(response => {
            this.$uloc.loading.hide()
            this.gerando = false
          })
          .catch(error => {
            this.gerando = false
            this.$uloc.loading.hide()
            this.alertApiError(error)
          })
    }
  },
  components: {
    ComarcaSelect,
    VaraSelect,
    TribunalSelect,
    GlobalPessoaInput,
    DatetimeModernInput,
    ErpSField,
    ECol,
    ERow,
    RelHeader,
    UInput
  }
}
</script>
